module.exports = __webpack_public_path__ + "img/DW365-129.d52f05e2.jpg";